import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import FormPermissionService from "../../Setup/controller/FormPermissionController/FormPermissionController";
import CreateAgreement from "./AgreementForms/CreateAgreement";
import AgreementNotificationList from "./AgreementForms/AgreementNotificationList";
import AgreementLog from "./AgreementForms/AgreementLog";
import AgreementDocumentList from "./AgreementForms/AgreementDocumentList";
import UpdateAgreementNotesPage from "./AgreementForms/UpdateAgreementNotes";
import AgreementExpired from "./AgreementForms/AgreementExpired";
import AgreementReports from "./AgreementForms/AgreementReports";
import AgreementUserDefineFields from "./AgreementForms/AgreementUserDefineFields";
import Draggable from 'react-draggable';
import JobsListPage from "../../Jobs/View/JobsList";
import AgreementService from "../Controller/AgreementController";
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import HelpSite from "../../Common/HelpLink";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
    Invoices: 22,
};
function AgreementDetail({ AgreementID, onClose, onSuccess, ClientCompanyID }) {
    const navigate = useNavigate();
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AdministrationSetting";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    const [isMinimized, setIsMinimized] = useState(false);
    const [assetName, setAssetName] = useState("Agreement Details");
    const [activeTab, setActiveTab] = useState('tab-Asset');
    const [currentAssetID, setCurrentAssetID] = useState(AgreementID);
    const [isLock, setIsLock] = useState(0);
    const UserID = localStorage.getItem("UserID");
    const [assignedModules, setAssignedModules] = useState(new Set());
    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    useEffect(() => {
        setCurrentAssetID(AgreementID);
        setActiveTab('tab-details');
        if (AgreementID > 0) {
            fetchAgreementDetail(AgreementID);
            fetchAssignedModules();
        }
        else {
            setAssetName("Agreement Details");
        }
    }, [AgreementID]);
    const fetchAgreementDetail = async (newAgreementID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            if (newAgreementID > 0) {
                const agreementDetail = await AgreementService.GetAgreementByID(redirectCallback, newAgreementID);
                // setAssetName(agreementDetail[0].contractNumber);

                setAssetName(`${agreementDetail[0].CompanyName} - ${agreementDetail[0].contractNumber}`);
                debugger;
                if (agreementDetail[0].isLock === 1 && agreementDetail[0].LockBy != UserID) {
                    setIsLock(1);
                }
                else {
                    setIsLock(0);
                    await AgreementService.LockContract(newAgreementID);
                }
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const handleSuccess = async () => {
        debugger;
        const newAgreementID = parseInt(localStorage.getItem('AgreementID'), 10);
        setCurrentAssetID(newAgreementID);
        await fetchAgreementDetail(newAgreementID);
    };
    let tabClass = (currentAssetID > 0) ? "nav-link" : "nav-link disabled";
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const modules = await ModuleService.GetRoleModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    const changeTab = (tab) => {
        setActiveTab(tab);

    };
    return (
        <div className="modal fade agreementPopupModal show d-block" id="agreementPopupModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
            <div className={`modal-dialog ${ClientCompanyID > 0 ? 'modal-lg' : 'modal-xl'}`}>
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                    bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{assetName} <strong style={{ fontSize: "14px", color: "red" }}> {isLock === 0 ? "" : "(Locked)"}</strong></h5>
                            <span>
                                <button type="button" className="close" onClick={onClose} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize">
                                    <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                </button>

                            </span>
                        </div>
                        {!isMinimized && (
                            <div className="modal-body" style={{ flex: "1" }}>
                                <div className="row vertical-pills-tab">
                                    <div className="d-flex justify-content-between align-items-center" style={{ marginLeft: "20px", marginRight: "25px", width: "100%", background: "#fff", borderBottom: "1px solid #d8e0e3" }}>
                                        <ul className="nav nav-tabs" style={{ border: "none", borderColor: "none" }}>
                                            <li className="nav-item">
                                                <a style={{ padding: "0.2rem" }} className={`nav-link ${activeTab === 'tab-details' ? 'active' : ''}`} onClick={() => changeTab('tab-details')} data-toggle="pill" href="#tab-details">
                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        <img src="assets/img/resources/agg_details.png" style={{ width: "25px", height: "25px" }} />
                                                        <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Details</strong>
                                                    </div>
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-notification' ? 'active' : ''}`} onClick={() => changeTab('tab-notification')} data-toggle="pill" href="#tab-notification">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_notifications.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notif...</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_notifications.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notif...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">

                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-document' ? 'active' : ''}`} onClick={() => changeTab('tab-document')} data-toggle="pill" href="#tab-document">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_documents.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Docu...</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-notes' ? 'active' : ''}`} onClick={() => changeTab('tab-notes')} data-toggle="pill" href="#tab-notes">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_notes-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_notes-history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Notes</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {/* {isLock === 0 ? (
                                                <a className={`${tabClass} ${activeTab === 'tab-userDefineFields' ? 'active' : ''}`} onClick={() => setActiveTab('tab-userDefineFields')} data-toggle="pill" href="#tab-notes">User Define Fields</a>
                                            ) : (
                                                <a className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                    User Define Fields
                                                </a>
                                            )}*/}
                                                {assignedModules.has(MODULE_IDS.Jobs) && isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-history' ? 'active' : ''}`} onClick={() => changeTab('tab-history')} data-toggle="pill" href="#tab-history">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_history.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Job History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_history.png" style={{ width: "25px", height: "25px" }} />
                                                           <strong className="top-text" style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>
                                                                {"Job History".split(" ").map((word, i) => (
                                                                    <span key={i} className="top-word">
                                                                        {word}
                                                                    </span>
                                                                ))}
                                                            </strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">

                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-log' ? 'active' : ''}`} onClick={() => changeTab('tab-log')} data-toggle="pill" href="#tab-log">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_log.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Log</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_log.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Log</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                                {isLock === 0 ? (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} ${activeTab === 'tab-expired' ? 'active' : ''}`} onClick={() => changeTab('tab-expired')} data-toggle="pill" href="#tab-expired">
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_expired.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Expired</strong>
                                                        </div>
                                                    </a>
                                                ) : (
                                                    <a style={{ padding: "0.2rem" }} className={`${tabClass} disabled`} href="#" style={{ pointerEvents: 'none', opacity: "0.5",padding: "0.2rem" }}>
                                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                            <img src="assets/img/resources/agg_expired.png" style={{ width: "25px", height: "25px" }} />
                                                            <strong style={{ fontSize: "10px", marginTop: "3px", color: "#333" }}>Expired</strong>
                                                        </div>
                                                    </a>
                                                )}
                                            </li>
                                            
                                        </ul>
                                        <div className="ml-auto">
                                            {activeTab === "tab-details" && (
                                                <HelpSite FormName="Detail" Module="10" />
                                            )}
                                            {activeTab === "tab-notification" && (
                                                <HelpSite FormName="Notification" Module="10" />
                                            )}
                                            {activeTab === "tab-document" && (
                                                <HelpSite FormName="Documents" Module="10" />
                                            )}
                                            {activeTab === "tab-notes" && (
                                                <HelpSite FormName="Notes" Module="10" />
                                            )}
                                            {activeTab === "tab-history" && (
                                                <HelpSite FormName="Job History" Module="10" />
                                            )}
                                            {activeTab === "tab-log" && (
                                                <HelpSite FormName="Documents" Module="10" />
                                            )}
                                            {activeTab === "tab-expired" && (
                                                <HelpSite FormName="Expired" Module="10" />
                                            )}
                                            {activeTab === "tab-reports" && (
                                                <HelpSite FormName="Report" Module="3" />
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 pl-0">
                                        <div className="tab-content p-3" id="v-pills-tabContent">
                                            <div className={`tab-pane fade ${activeTab === 'tab-details' ? 'show active' : ''}`} id="tab-details" role="tabpanel">
                                                <CreateAgreement AgreementID={parseInt(currentAssetID, 10)} onSuccess={handleSuccess} ClientCompanyID={ClientCompanyID} isLock={isLock} onClose={onClose} />
                                            </div>
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-notification' ? 'show active' : ''}`} id="tab-notification" role="tabpanel">
                                                    <AgreementNotificationList AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-document' ? 'show active' : ''}`} id="tab-document" role="tabpanel">
                                                    <AgreementDocumentList AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-notes' ? 'show active' : ''}`} id="tab-notes" role="tabpanel">
                                                    <UpdateAgreementNotesPage AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-userDefineFields' ? 'show active' : ''}`} id="tab-userDefineFields" role="tabpanel">
                                                    <AgreementUserDefineFields AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && assignedModules.has(MODULE_IDS.Jobs) && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-history' ? 'show active' : ''}`} id="tab-history" role="tabpanel">
                                                    <JobsListPage CustomerID={parseInt("0")} AssetID={parseInt("0")} StockID={parseInt("0")} ContractID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-log' ? 'show active' : ''}`} id="tab-log" role="tabpanel">
                                                    <AgreementLog AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}

                                            {currentAssetID > 0 && (
                                                <div className={`tab-pane fade ${activeTab === 'tab-expired' ? 'show active' : ''}`} id="tab-expired" role="tabpanel">
                                                    <AgreementExpired AgreementID={parseInt(currentAssetID, 10)} isLock={isLock} />
                                                </div>
                                            )}
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </Draggable>
            </div>
        </div>
    );
}

export default AgreementDetail;
